import React, { useState } from "react";
import "../Components/style/RegisterStyle.css";
import img from "../image/Image _ Page/Contact_page//main-banner.jpg";
import axios from 'axios';

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company:"",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // Validate form data (optional)
      if (!formData.name || !formData.email || !formData.phone || !formData.company ) {
        alert("Please fill in all required fields.");
        return;
      }
  
      // Send the form data to the server
      const response = await axios.post("http://localhost:3001/contact", formData);

  
      if (response.status === 201) {
        alert("Form submitted successfully!");
        console.log("Response from server:", response.data);
        // Clear the form
        setFormData({ name: "", email: "", phone: "", company: "", message: "" });
      } else {
        alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };
  

  return (
    <div className="register-page">
      {/* Top Section with Image */}
      <div
        className="top-section"
        style={{
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <h1 style={{ color: "white", fontSize: "3rem", textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)" }}>
          Welcome to Registration
        </h1> */}
      </div>

      <div class="enhanced-section">
    <h1>Ready to supercharge your Productivity and efficiency!</h1>
    <p> Don’t miss out on the opportunity to transform your business with our cutting-edge IT solutions. Contact us today to schedule a demo, get a personalized quote, or ask any questions you may have. Let’s take your business to the next level – together!</p>
</div>



    {/* Form Section */}
<div className="form-container">
  <div className="form-content">
    {/* Left Side: Contact Information */}
    <div className="contact-section">
  <div className="contact-heading">
    <h3><strong>Get in Touch</strong></h3>
  </div>
  <p className="contact-description">
    Give us a call or drop by anytime. We endeavor to answer all inquiries within 24 hours on business days. 
    We will be happy to answer your questions.
  </p>
  <div className="contact-icons">
    <div className="contact-item">
      <span className="contact-icon">
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z">
          </path>
        </svg>
      </span>
      {/* <span className="contact-label">
        <strong>Phone</strong><br />
        <a href="tel:01147593526" aria-label="Phone">
                    011-47593526
                  </a>
      </span> */}
      <span class="contact-label">
  <strong>Phone</strong><br/>
  <a href="tel:+91xxxxxx" aria-label="Phone: +91-xxxxxxxx">
    +91 xxxxxx    
  </a>
</span>
    </div>
    <div className="contact-item">
      <span className="contact-icon">
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z">
          </path>
        </svg>
      </span>
      <span className="contact-label">
        <strong>Email</strong><br />
        <a href="mailto:info@orryx.in" aria-label="Email">
            info@orryx.in
          </a>
      </span>
    </div>
    <div className="contact-item">
      <span className="contact-icon">
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path d="M384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384z">
          </path>
        </svg>
      </span>
      <span className="contact-label">
        <strong>Address</strong><br />
        <a target="_blank" rel="noopener noreferrer" aria-label="View our address on Google Maps">
        Building No.837, Road/Street: KAMAL COLONY,  Kamla Girls Hostel, Rohtak,  State: Haryana. PIN Code: 124001

                  </a>
      </span>
    </div>
  </div>
</div>


    {/* Right Side: Registration Form */}
    <div className="form-wrapper">
      <h2>Book a Call or Register</h2>
      <p>Fill in the details below and we’ll get back to you shortly.</p>
      <form onSubmit={handleSubmit} className="register-form">
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Enter your phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>


        <div className="form-group">
          <label htmlFor="phone">Company </label>
          <input
            type="tel"
            id="company"
            name="company"
            placeholder="Enter your company"
            value={formData.company}
            onChange={handleChange}
            required
          />
        </div>



        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Your message or inquiry..."
            rows="4"
            value={formData.message}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
    </div>
  </div>
</div>

    </div>
  );
};

export default Register;
